import { isNumber } from 'lodash/fp';
import { memo } from '../util/memoizationUtils';
import BackendService from './BackendService';

const VERBOSE_PAYMENTS_HEADERS = 'x-verbose-payments';

export default class PaymentsService {
  static memoizedGetPaymentsForPencilBody = memo(
    PaymentsService.noMemoizedGetPaymentsForPencilBody,
  );

  static getPaymentsForPencilId(dealId, pencilId, clientType, verbose = false) {
    const params = {
      multipleLeaseTerms: true,
    };
    if (pencilId) {
      params.pencilId = pencilId;
    }
    return BackendService.get(`/payments/${clientType}/${dealId}`, {
      params,
      headers: { [VERBOSE_PAYMENTS_HEADERS]: !!verbose },
    });
  }

  static getPaymentsForPencilBody(dealId, pencil, clientType, verbose = false) {
    const reqObj = { dealId, pencil, clientType, verbose };
    return PaymentsService.memoizedGetPaymentsForPencilBody(reqObj);
  }

  // this is the same as getPaymentsForPencilId except here the entire pencil is sent to the backend
  // this is needed because chairman can have a newer pencil than what's saved on the backend
  static noMemoizedGetPaymentsForPencilBody({
    dealId,
    pencil,
    clientType,
    verbose = false,
  }) {
    // (actually a post instead of a get, but doesn't result in anything updating)
    return BackendService.post(`/payments/${clientType}/${dealId}`, {
      headers: { [VERBOSE_PAYMENTS_HEADERS]: !!verbose },
      body: pencil,
    });
  }
  static getPaymentsForCar(
    clientType,
    dealerId,
    carId,
    creditRating,
    downPayment,
    verbose = false,
  ) {
    const params = {
      dealerId,
      creditRating,
      ...(isNumber(downPayment) && { downPayment }),
    };
    return BackendService.get(`/payments/${clientType}/car/${carId}`, {
      params,
      headers: { [VERBOSE_PAYMENTS_HEADERS]: !!verbose },
    });
  }
  static getPaymentsForFinanceResponse(financeResponse, params) {
    return BackendService.post('/payments/financeResponse', {
      body: financeResponse,
      params,
    });
  }
}
